import React, { lazy, Suspense, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { isAdmin } from '../../../helpers/roleHelpers';
import CourseTrainingCatalog from './CourseTrainingCatalog';
import { academyGet } from './academyApi';
import './SalesAcademy.css';
const CourseTrainingEditor = lazy(() => import('./CourseTrainingEditor'));
const AcademyTeamProgress = lazy(() => import('./AcademyTeamProgress'));
const AcademyWorkspace = lazy(() => import('./AcademyWorkspace'));
export const COURSE_TRAINING_VIEW_BASE = '/sales-academy';
export const COURSE_TRAINING_MANAGE_BASE = '/admin/manage-sales-academy';

function CourseTrainingIndex() {
  const location = useLocation();
  const history = useHistory();
  const { courseId: courseIdParam } = useParams();
  const [courses, setCourses] = useState([]);
  const [listLoading, setListLoading] = useState(true);
  const [listError, setListError] = useState('');
  const [listSearchInput, setListSearchInput] = useState('');
  const userCanManageCourses = useMemo(() => isAdmin(), []);
  const isManageRoute = location.pathname.startsWith(COURSE_TRAINING_MANAGE_BASE);
  const canManageCourses = userCanManageCourses && isManageRoute;
  const playerCourseId = courseIdParam ? String(courseIdParam) : null;
  const isTeamView = !playerCourseId && userCanManageCourses && new URLSearchParams(location.search).get('view') === 'team';
  const workspaceView = !playerCourseId && new URLSearchParams(location.search).get('workspace');
  const requestRef = useRef(null);
  const loadCourses = useCallback(async () => {
    if (requestRef.current) requestRef.current.abort();
    const controller = new AbortController();
    requestRef.current = controller;
    setListLoading(true); setListError('');
    const result = await academyGet('/courses/catalog', controller.signal);
    if (controller.signal.aborted) return;
    setListLoading(false);
    if (result.error) { setListError(result.error); return; }
    setCourses((result.response?.results || []).map(c => ({ ...c, modules: [] })));
  }, []);

  useEffect(() => {
    if (!playerCourseId && !isTeamView && !workspaceView) loadCourses();
    return () => { if (requestRef.current) requestRef.current.abort(); };
  }, [playerCourseId, isTeamView, workspaceView, loadCourses]);

  const openViewCourse = (id, lessonId) => history.push(`${COURSE_TRAINING_VIEW_BASE}/${id}${lessonId ? `?lesson=${encodeURIComponent(lessonId)}` : ''}`);
  return <div className="position-relative"><Suspense fallback={<div className="academy-empty" role="status">Opening training…</div>}>
    {workspaceView ? <AcademyWorkspace view={workspaceView} /> : isTeamView ? <AcademyTeamProgress /> : playerCourseId ? <CourseTrainingEditor
      key={playerCourseId + (isManageRoute ? '-manage' : '-learn')} courseId={playerCourseId}
      initialLessonId={new URLSearchParams(location.search).get('lesson') || ''}
      viewOnly={!isManageRoute} canManageCourses={canManageCourses}
      onExitEditor={() => history.push(isManageRoute ? COURSE_TRAINING_MANAGE_BASE : COURSE_TRAINING_VIEW_BASE)}
    /> : <CourseTrainingCatalog courses={courses} setCourses={setCourses} canManageCourses={canManageCourses}
      listLoading={listLoading} listError={listError} listSearchInput={listSearchInput}
      onListSearchInputChange={setListSearchInput} onReloadList={loadCourses}
      onManageCourse={id => history.push(`${COURSE_TRAINING_MANAGE_BASE}/${id}`)} onViewCourse={openViewCourse} />}
  </Suspense></div>;
}
export default CourseTrainingIndex;
